/**

 * Google Sheets OAuth / selection flow helpers for campaign creation.

 */



export const CAMPAIGN_SHEETS_CONTEXTS = [

  'marketing-campaign',

  'renewal-campaign',

  'dynamic-campaign',

  'campaign-builder',

] as const;



export type CampaignSheetsContext = (typeof CAMPAIGN_SHEETS_CONTEXTS)[number];



export function isCampaignSheetsContext(context: string | null | undefined): context is CampaignSheetsContext {

  return !!context && (CAMPAIGN_SHEETS_CONTEXTS as readonly string[]).includes(context);

}



/** Where to send the user after they connect/select a sheet during campaign creation. */

export function getReturnPathAfterSheetsConnect(context: string | null | undefined): string {

  if (context === 'campaign-builder') {

    return '/campaign-builder?from=google-sheets&step=2';

  }

  if (isCampaignSheetsContext(context) && context !== 'campaign-builder') {
    return '/renewal-builder?from=google-sheets&step=data';
  }

  return '/google-sheets';

}



/** Where to send the user right after Google account OAuth (before picking a sheet). */

export function getSelectSheetsPathAfterOAuth(context: string | null | undefined): string {

  if (isCampaignSheetsContext(context)) {

    return `/select-sheets?auth=success&context=${encodeURIComponent(context)}`;

  }

  return '/select-sheets?auth=success&context=integrations';

}



export function parseCampaignBuilderStepFromQuery(step: string | null): number | null {

  if (!step) return null;

  if (step === 'data') return 2;

  const n = parseInt(step, 10);

  if (n >= 1 && n <= 4) return n;

  return null;

}


